"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.string.iterator");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _choices = _interopRequireDefault(require("choices.js/public/assets/scripts/choices.js"));

var _lodash = _interopRequireDefault(require("lodash"));

var _Formio = _interopRequireDefault(require("../../Formio"));

var _storage = require("../../storage");

var _WithLogic2 = _interopRequireDefault(require("../../utils/WithLogic"));

var _Base = _interopRequireDefault(require("../base/Base.form"));

var _utils = _interopRequireDefault(require("../base/editForm/utils"));

var _Select = _interopRequireDefault(require("./Select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var catalogs = _storage.formioStorage.catalogs;
var categories = _storage.formioStorage.categories; // Отличается от обычного Select из formio следующими особенностями:
//
// 1. Из стандартынх dataSource типов оставлены только "values", "json", "url" и "custom"
//
// 2. Для типа "url" можно указать функцию extractValues, которая смаппит полученный ответ в [{code: '', title: ''}, ...]
//    Если в качестве url указан относительный адрес (начинающийся не с http), к нему слева будет добавлен options.baseUrl
//    (todo выпилить приписку baseUrl, когда все forms-ui переедут на другие типы селекта или все url исправят на абсолютные)
//
// 3. Новый тип селекта "catalog": получает все доступные айтемы по options.catalogsUrl/catalogItems?catalogCode=:catalog&lang=:lang,
//    а в текстовом виде, выбранные айтемы по options.catalogsUrl/catalogItem?code=:catalogItemCode&lang=:lang
//

function _default(options) {
  var baseUrl = options.baseUrl,
      catalogsUrl = options.catalogsUrl;

  var Select =
  /*#__PURE__*/
  function (_WithLogic) {
    _inherits(Select, _WithLogic);

    function Select() {
      _classCallCheck(this, Select);

      return _possibleConstructorReturn(this, _getPrototypeOf(Select).apply(this, arguments));
    }

    _createClass(Select, [{
      key: "setupValueElement",
      value: function setupValueElement(element) {
        this.asString().then(function (valueHtml) {
          element.innerHTML = valueHtml;
        });
      }
    }, {
      key: "onChange",
      value: function onChange(flags, fromRoot) {
        _get(_getPrototypeOf(Select.prototype), "onChange", this).call(this, flags, fromRoot);

        this.updatePlaceholder();
        !flags.isSetSubmission && flags.modified && this.triggerUnblockByUser();
      }
    }, {
      key: "updatePlaceholder",
      value: function updatePlaceholder() {
        if (this.choices && this.component.multiple) {
          if (this.dataValue.length) {
            this.choices.input.element.placeholder = '';
          } else {
            this.choices.input.element.placeholder = this.component.placeholder;
          }
        }
      }
    }, {
      key: "setItems",
      value: function setItems(items, fromSearch) {
        var _this = this;

        // If the items is a string, then parse as JSON.
        if (typeof items == 'string') {
          try {
            items = JSON.parse(items);
          } catch (err) {
            console.warn(err.message);
            items = [];
          }
        } // Allow js processing (needed for form builder)


        if (this.component.onSetItems && typeof this.component.onSetItems === 'function') {
          var newItems = this.component.onSetItems(this, items);

          if (newItems) {
            items = newItems;
          }
        }

        if (!this.choices && this.selectInput) {
          if (this.loading) {
            this.removeChildFrom(this.selectInput, this.selectContainer);
          }

          this.selectInput.innerHTML = '';
        } // If they provided select values, then we need to get them instead.


        if (this.component.selectValues) {
          items = _lodash.default.get(items, this.component.selectValues);
        }

        if (this.scrollLoading) {
          // Check if the first two items are equal, and if so, then we can assume that this is the same list
          // and we should skip over the loading.
          if (this.currentItems.length && items.length && _lodash.default.isEqual(this.currentItems[0], items[0]) && _lodash.default.isEqual(this.currentItems[1], items[1])) {
            this.stopInfiniteScroll();
            this.loading = false;
            return;
          } // If we have gone beyond our limit, then stop.


          if (items.limit && items.length < items.limit) {
            this.stopInfiniteScroll();
          } // Increment the loadedItems.


          this.loadedItems += items.length;
        } else {
          this.selectOptions = [];
          this.loadedItems = items.length;
        }

        this.currentItems = items; // Add the value options.

        if (!fromSearch) {
          this.addValueOptions(items);
        }

        if (this.component.widget === 'html5' && !this.component.placeholder) {
          this.addOption(null, '');
        } // Iterate through each of the items.


        _lodash.default.each(items, function (item) {
          _this.addOption(_this.itemValue(item), _this.itemTemplate(item));
        });

        if (this.choices) {
          this.choices.setChoices(this.selectOptions, 'value', 'label', true);
        } else if (this.loading) {
          // Re-attach select input.
          this.appendTo(this.selectInput, this.selectContainer);
        } // We are no longer loading.


        this.scrollLoading = false;
        this.loading = false; // If a value is provided, then select it.
        // Проверка значения на 0

        if (this.dataValue || this.dataValue === 0) {
          this.setValue(this.dataValue, true);
        } else if (this.component.autoSelectTheOnlyOption && items.length === 1) {
          this.setValue(items[0].value);
        } else {
          // If a default value is provided then select it.
          var defaultValue = this.defaultValue;

          if (defaultValue) {
            this.setValue(defaultValue);
          }
        } // Say we are done loading the items.


        this.itemsLoadedResolve();
      }
    }, {
      key: "setValue",
      value: function setValue(value, flags) {
        flags = this.getFlags.apply(this, arguments);
        var previousValue = this.dataValue;

        if (this.component.multiple && !Array.isArray(value)) {
          value = value ? [value] : [];
        }

        var hasPreviousValue = Array.isArray(previousValue) ? previousValue.length : previousValue;
        var hasValue = Array.isArray(value) ? value.length : value;
        var changed = this.hasChanged(value, previousValue);
        this.dataValue = value; // Do not set the value if we are loading... that will happen after it is done.
        // чувак, кто бы ты ни был, но ты не прав --^

        if (this.loading) {
          // Отличие от super.setValue ---------------------------------------------------------------------------|
          // Фикс и текстового, и обычного вида в следующей строчке
          // Эта строка порой вызывается до того, как options в селект загружены
          // Но они не нужны для установки значения, потому что влияют только на view
          // Ошибка была в том, что на момент загрузки options значение уже было установление и onChange не срабатывал
          this.updateOnChange(flags, changed);
          return changed;
        } // Determine if we need to perform an initial lazyLoad api call if searchField is provided.


        if (this.component.searchField && this.component.lazyLoad && !this.lazyLoadInit && !this.active && !this.selectOptions.length && hasValue) {
          this.loading = true;
          this.lazyLoadInit = true;
          this.triggerUpdate(this.dataValue, true);
          return changed;
        } // Add the value options.


        this.addValueOptions();

        if (this.choices) {
          // Now set the value.
          if (hasValue || hasValue === 0) {
            this.choices.removeActiveItems(); // Add the currently selected choices if they don't already exist.

            var currentChoices = Array.isArray(this.dataValue) ? this.dataValue : [this.dataValue];

            if (!this.addCurrentChoices(currentChoices, this.selectOptions, true)) {
              this.choices.setChoices(this.selectOptions, 'value', 'label', true);
            }

            this.choices.setChoiceByValue(value);
          } else if (hasPreviousValue) {
            this.choices.removeActiveItems();
          }
        } else {
          if (hasValue || hasValue === 0) {
            var values = Array.isArray(value) ? value : [value];

            _lodash.default.each(this.selectOptions, function (selectOption) {
              _lodash.default.each(values, function (val) {
                if (_lodash.default.isEqual(val, selectOption.value)) {
                  selectOption.element.selected = true;
                  selectOption.element.setAttribute('selected', 'selected');
                  return false;
                }
              });
            });
          } else {
            _lodash.default.each(this.selectOptions, function (selectOption) {
              selectOption.element.selected = false;
              selectOption.element.removeAttribute('selected');
            });
          }
        }

        this.updateOnChange(flags, changed);
        return changed;
      }
    }, {
      key: "setValuesItems",
      value: function setValuesItems(values) {
        if (this.component.data.transform) {
          var items = this.evaluate(this.component.data.transform, {
            values: values
          }, 'values');
          this.setItems(items);
          return;
        }

        this.setItems(values);
      }
    }, {
      key: "addOption",
      value: function addOption(value, label, attr) {
        var option = {
          value: value,
          label: label
        }; // Дополнил проверку value, т.к если value = 0 и это число,
        // проверка не проходит и не отображается option со значением === 0

        if (value || value === 0) {
          this.selectOptions.push(option);
        }

        if (this.choices) {
          return;
        }

        option.element = document.createElement('option');

        if (this.dataValue === option.value) {
          option.element.setAttribute('selected', 'selected');
          option.element.selected = 'selected';
        }

        option.element.innerHTML = label;

        if (attr) {
          _lodash.default.each(attr, function (value, key) {
            option.element.setAttribute(key, value);
          });
        }

        if (this.selectInput) {
          this.selectInput.appendChild(option.element);
        }
      }
    }, {
      key: "getUrlWithCustomQueryParameter",
      value: function getUrlWithCustomQueryParameter(url) {
        var customQueryParameterResult = this.evaluate(this.component.customQueryParameter, {}, 'result');

        if (customQueryParameterResult) {
          var encodedCustomQueryParameter;

          try {
            encodedCustomQueryParameter = encodeURIComponent(JSON.stringify(customQueryParameterResult)); // eslint-disable-next-line no-empty
          } catch (_unused) {
            console.error("Невозможно закодировать объект из поля 'JS-скрипт для получения данных справочника'");
          }

          if (encodedCustomQueryParameter) {
            var urlWithCustomQueryParameter = new URL(url);
            urlWithCustomQueryParameter.searchParams.append('query', encodedCustomQueryParameter);
            url = urlWithCustomQueryParameter.toString();
          }
        }

        return url;
      }
    }, {
      key: "updateItems",
      value: function updateItems(searchInput, forceUpdate) {
        var _this2 = this;

        if (!this.component.data) {
          console.warn('Select component '.concat(this.key, ' does not have data configuration.'));
          this.itemsLoadedResolve();
          return;
        } // Only load the data if it is visible.


        if (!this.checkConditions()) {
          this.itemsLoadedResolve();
          return;
        }

        if (this.component.dataSrc !== 'custom' && !this.component.valueProperty) {
          this.component.valueProperty = this.originalComponent.valueProperty = 'value';
        }

        switch (this.component.dataSrc) {
          case 'values':
            this.setValuesItems(this.component.data.values);
            this.stopInfiniteScroll();
            break;

          case 'json':
            this.setItems(this.component.data.json);
            this.stopInfiniteScroll();
            break;

          case 'custom':
            this.updateCustomItems();
            break;

          case 'url':
            {
              if (!forceUpdate && !this.active) {
                // If we are lazyLoading, wait until activated.
                return;
              }

              var url = this.component.data.url; // Отличие от super.updateItems --------------------------------------------------------------------|
              // Сделано для поддержки случаев, когда в параметре url указан относительный адрес, например:
              // catalogs/api/catalogItems/OKVED

              url = url.startsWith('http') ? url : "".concat(baseUrl, "/").concat(url);

              if (this.component.customQueryParameter) {
                url = this.getUrlWithCustomQueryParameter(url);
              }

              this.loadItems(url, searchInput); // -------------------------------------------------------------------------------------------------|

              break;
            }
          // Отличие от super.updateItems ------------------------------------------------------------------------|
          // Новый тип источника данных: catalog

          case 'catalog':
            {
              var catalogCode = this.component.data.catalogCode;

              if (_storage.catalogsCode.has(catalogCode)) {
                var waitCatalogList = setInterval(function () {
                  _this2.loading = true;

                  if (catalogs[catalogCode]) {
                    _this2.loading = false;

                    _this2.setItems(catalogs[catalogCode], !!searchInput);

                    clearInterval(waitCatalogList);
                  }
                }, 100);
                break;
              }

              if (catalogCode !== '') {
                _storage.catalogsCode.add(catalogCode);
              }

              if (!forceUpdate && !this.active) {
                // If we are lazyLoading, wait until activated.
                return;
              }

              if (!catalogCode || _lodash.default.isEmpty(catalogCode)) {
                this.itemsLoadedResolve();
                return;
              }

              var lang = this.i18next.language;

              var _url = "".concat(catalogsUrl, "/catalogItems?catalogCode=").concat(encodeURIComponent(catalogCode), "&lang=").concat(lang);

              _url = _url.startsWith('http') ? _url : "".concat(baseUrl, "/").concat(_url);
              this.loading = true; // зря избавились от options, они нужны

              var _options = this.component.authenticate ? {} : {
                noToken: true
              };

              _options.header = this.requestHeaders;

              _Formio.default.makeRequest(this.options.formio, 'select', _url, 'GET', null, _options).then(function (response) {
                _this2.loading = false;
                var scrollTop = !_this2.scrollLoading && _this2.currentItems.length === 0;
                var items = response.map(function (i) {
                  return {
                    value: "".concat(i.code, "@").concat(i.catalogCode),
                    label: i.title
                  };
                });

                _this2.setItems(items, !!searchInput);

                catalogs[catalogCode] = items;

                if (scrollTop && _this2.choices) {
                  _this2.choices.choiceList.scrollToTop();
                }
              }).catch(function (err) {
                _this2.stopInfiniteScroll();

                _this2.loading = false;

                _this2.itemsLoadedResolve();

                _this2.emit('componentError', {
                  component: _this2.component,
                  message: err.toString()
                });

                catalogs[catalogCode] = [];
                console.warn("Unable to load resources for ".concat(_this2.key));
              });

              break;
            }
          // -----------------------------------------------------------------------------------------------------|
        }
      } // Вызывается в режиме редактирования

    }, {
      key: "loadItems",
      value: function loadItems(url, search) {
        var _this3 = this;

        // See if they have not met the minimum search requirements.
        var minSearch = parseInt(this.component.minSearch, 10);

        if (this.component.searchField && minSearch > 0 && (!search || search.length < minSearch)) {
          // Set empty items.
          return this.setItems([]);
        }

        var limit = this.component.limit || 100;
        var skip = this.loadedItems || 0;
        var query = this.component.dataSrc === 'url' || this.component.dataSrc === 'catalog' ? {} : {
          limit: limit,
          skip: skip
        };
        url = this.getUrlInterpolate(url, search); // Add search capability.

        if (this.component.searchField && search) {
          if (Array.isArray(search)) {
            query["".concat(this.component.searchField, "__in")] = search.join(',');
          } else {
            query["".concat(this.component.searchField, "__regex")] = search;
          }
        } // If they wish to return only some fields.


        if (this.component.selectFields) {
          query.select = this.component.selectFields;
        } // Add sort capability


        if (this.component.sort) {
          query.sort = this.component.sort;
        }

        if (!_lodash.default.isEmpty(query)) {
          // Add the query string.
          url += (!url.includes('?') ? '?' : '&') + _Formio.default.serialize(query, function (item) {
            return _this3.interpolate(item);
          });
        } // Add filter capability


        if (this.component.filter) {
          url += (!url.includes('?') ? '?' : '&') + this.interpolate(this.component.filter);
        } // Make the request.


        this.loading = true;
        var options = this.component.authenticate ? {} : {
          noToken: true
        };
        options.header = this.requestHeaders;

        _Formio.default.makeRequest(this.options.formio, 'select', url, 'GET', null, options).then(function (response) {
          _this3.loading = false;
          var scrollTop = !_this3.scrollLoading && _this3.currentItems.length === 0; // Отличие от super.loadItems ----------------------------------------------------------------------|
          // Преобразуем данные полученные по url, с помощью функции extractValues (если она указана юзером)

          var items = _this3._extractItems(response); // -------------------------------------------------------------------------------------------------|


          _this3.setItems(items, !!search);

          if (scrollTop && _this3.choices) {
            _this3.choices.choiceList.scrollToTop();
          } // Устанавливаем коды выбранных опций по-умолчанию -------------------------------------------------|


          if (!_this3.pristine) {
            return;
          }

          var defaultCodes = _this3.component.defaultCodes || '';
          var isMultiple = _this3.component.multiple;
          var defaultCodesArray = defaultCodes.split(',').map(function (code) {
            return code.trim();
          });
          var defaultItems = items.filter(function (item) {
            return defaultCodesArray.includes(item.code);
          });
          var defaultItemsCodes = defaultItems.map(function (item) {
            return item.code;
          });
          var isFormWasSubmitted = _this3.root._submission.state === 'submitted';

          if (defaultItemsCodes.length && !isFormWasSubmitted) {
            var changed = _this3.hasChanged(defaultItemsCodes, _this3.dataValue);

            _this3.setValue(isMultiple ? defaultItemsCodes : defaultItemsCodes.reverse()[0], changed);
          } // -------------------------------------------------------------------------------------------------|

        }).catch(function (err) {
          _this3.stopInfiniteScroll();

          _this3.loading = false;

          _this3.itemsLoadedResolve();

          _this3.emit('componentError', {
            component: _this3.component,
            message: err.toString()
          });

          console.warn("Unable to load resources for ".concat(_this3.key));
        });
      }
    }, {
      key: "getUrlInterpolate",
      value: function getUrlInterpolate(url, search) {
        var limit = this.component.limit || 100;
        var skip = this.loadedItems || 0;

        if (url.indexOf('{{') !== -1) {
          // Для элементов внутри EditGrid
          if (!this.root._submission) {
            var submission = this.root._submission = {};
            submission.data = this.component.form;
          }
        } // Allow for url interpolation.


        url = this.interpolate(url, {
          formioBase: _Formio.default.getBaseUrl(),
          search: search,
          limit: limit,
          skip: skip,
          page: Math.abs(Math.floor(skip / limit))
        });
        return url;
      } // asString - возвращает промис, поэтому для multiply получался массив с промисами

    }, {
      key: "getView",
      value: function () {
        var _getView = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(data) {
          var values;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(this.component.multiple && Array.isArray(data))) {
                    _context.next = 10;
                    break;
                  }

                  values = data.map(this.asString.bind(this));

                  if (!(values[0] && values[0].then)) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 5;
                  return Promise.all(values);

                case 5:
                  _context.t0 = _context.sent;
                  _context.next = 9;
                  break;

                case 8:
                  _context.t0 = values;

                case 9:
                  return _context.abrupt("return", _context.t0);

                case 10:
                  return _context.abrupt("return", this.asString(data));

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function getView(_x) {
          return _getView.apply(this, arguments);
        }

        return getView;
      }() // Вызывается в текстовом виде

    }, {
      key: "asString",
      value: function asString(value, element) {
        var _this4 = this;

        value = value || this.getValue();

        if (['values', 'custom'].includes(this.component.dataSrc)) {
          var _ref = this.component.dataSrc === 'values' ? {
            items: this.component.data.values,
            valueProperty: 'value'
          } : {
            items: this.getCustomItems(),
            valueProperty: this.component.valueProperty
          },
              items = _ref.items,
              valueProperty = _ref.valueProperty;

          if (this.component.multiple && Array.isArray(value) && value.some(function (valueItem) {
            return _typeof(valueItem) === 'object';
          })) {
            value = value.map(function (valueItem) {
              return valueItem.value;
            });
          }

          value = this.component.multiple && Array.isArray(value) ? _lodash.default.filter(items, function (item) {
            return value.includes(item.value);
          }) : valueProperty ? _lodash.default.find(items, [valueProperty, value]) : value;
        } // Отличие от super.loadItems ------------------------------------------------------------------------------|
        // Для типа селекта "URL" в текстовом виде (только в нём вызывается asString), получаем весь справочник по
        // указанному адресу, ищем в нём текущие выбранные айтемы и применяем к ним itemTemplate


        if (this.component.dataSrc === 'url' && this.component.data.url) {
          return this._getAllItems(this.component.data.url).then(function (allItems) {
            var items = (Array.isArray(value) ? value : [value]).filter(function (v) {
              return !_lodash.default.isEmpty(v);
            }).map(function (v) {
              var item = (allItems || []).find(function (i) {
                return i.value === v || i.code === v || i.id === v;
              });

              if (!item) {
                console.error("\u042D\u043B\u0435\u043C\u0435\u043D\u0442 ".concat(v, " \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D \u0432 \u0442\u0435\u043A\u0443\u0449\u0435\u043C \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0435"));
                return v;
              } else {
                return _this4.itemTemplate(item);
              }
            });
            return items.length > 0 ? items.join('<br />') : '-';
          });
        } // Для типа селекта "Catalog" в текстовом виде (только в нём вызывается asString), получаем айтем по
        // каждому выбранному значению отдельным запросом, затем к полученным данным применяем itemTemplate


        if (this.component.dataSrc === 'catalog') {
          this.loading = true; //todo Сделать в catalog-сервисе api для получения инфы по нескольким айтемам одним запросом

          var itemPromises = (Array.isArray(value) ? value : [value]).filter(function (v) {
            return !_lodash.default.isEmpty(v);
          }).map(function (v) {
            if (_lodash.default.isObject(v) && !!v.value) {
              return v.value;
            }

            return v;
          }).map(function (v) {
            if (_storage.categoriesCode.has(v)) {
              return new Promise(function (resolve) {
                var waitCategoriesItem = setInterval(function () {
                  if (categories[v]) {
                    resolve(categories[v]);
                    clearInterval(waitCategoriesItem);
                  }
                }, 100);
              });
            } else {
              _storage.categoriesCode.add(v);

              var lang = _this4.i18next.language;
              var url = "".concat(catalogsUrl, "/catalogItem?code=").concat(encodeURIComponent(v), "&lang=").concat(lang);
              return _Formio.default.makeRequest(_this4.options.formio, 'select', url, 'GET').then(function (response) {
                _this4.loading = false;
                categories[v] = response;
                return response;
              }).catch(function (err) {
                _this4.loading = false;

                _this4.emit('componentError', {
                  component: _this4.component,
                  message: err.toString()
                });

                categories[v] = {};
                console.warn("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C '".concat(v, "' \u0434\u043B\u044F \u043F\u043E\u043B\u044F ").concat(_this4.key));
              });
            }
          });
          return Promise.all(itemPromises).then(function (items) {
            items = items.map(function (i) {
              return _this4.itemTemplate({
                value: "".concat(i.code, "@").concat(i.catalogCode),
                label: i.title
              });
            });
            return items.length > 0 ? items.join('<br />') : '-';
          });
        } // ---------------------------------------------------------------------------------------------------------|


        if (_lodash.default.isString(value)) {
          return Promise.resolve(value);
        }

        if (Array.isArray(value)) {
          var _items = [];
          value.forEach(function (item) {
            return _items.push(_this4.itemTemplate(item));
          });
          return Promise.resolve(_items.length > 0 ? _items.join('<br />') : '-');
        }

        return Promise.resolve(!_lodash.default.isNil(value) ? this.itemTemplate(value) : '-');
      }
    }, {
      key: "_getAllItems",
      value: function _getAllItems(url) {
        var _this5 = this;

        if (this.currentItems && this.currentItems.length) {
          return Promise.resolve(this.currentItems);
        }

        if (!this.itemsPromise) {
          url = url.startsWith('http') ? url : "".concat(baseUrl, "/").concat(url);
          url = this.getUrlInterpolate(url);

          if (this.component.customQueryParameter) {
            url = this.getUrlWithCustomQueryParameter(url);
          }

          this.itemsPromise = _Formio.default.makeRequest(this.options.formio, 'select', url, 'GET').then(function (response) {
            var items = _this5._extractItems(response);

            _this5.currentItems = items;
            return items;
          }).catch(function (err) {
            console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u0434\u043B\u044F \u043F\u043E\u043B\u044F ".concat(_this5.key));
            console.error(err);
          });
        }

        return this.itemsPromise;
      }
    }, {
      key: "_extractItems",
      value: function _extractItems(response) {
        var items = response;

        if (this.component.data.extractValues && !_lodash.default.isEmpty(this.component.data.extractValues)) {
          items = this.evaluate(this.component.data.extractValues, {
            values: [],
            response: response
          }, 'values');
        }

        return items;
      }
    }, {
      key: "addInput",
      value: function addInput(input, container) {
        var _this6 = this;

        this.defaultAddInput(input, container);

        if (this.component.multiple) {
          input.setAttribute('multiple', true);
        }

        if (this.component.widget === 'html5') {
          this.triggerUpdate();
          this.focusableElement = input;
          this.addEventListener(input, 'focus', function () {
            return _this6.update();
          });
          this.addEventListener(input, 'keydown', function (event) {
            var keyCode = event.keyCode;

            if ([8, 46].includes(keyCode)) {
              _this6.setValue(null);
            }
          });
          return;
        }

        var useSearch = this.component.hasOwnProperty('searchEnabled') ? this.component.searchEnabled : true;
        var placeholderValue = this.t(this.component.placeholder);
        var customOptions = this.component.customOptions || {};

        if (typeof customOptions == 'string') {
          try {
            customOptions = JSON.parse(customOptions);
          } catch (err) {
            console.warn(err.message);
            customOptions = {};
          }
        }

        var customSearch = this.component.customSearch || {};

        if (typeof customSearch == 'string') {
          try {
            customSearch = JSON.parse(customSearch);
          } catch (err) {
            console.warn(err.message);
            customSearch = {};
          }
        }

        var searchField = this.component.searchField;
        var choicesOptions = {
          removeItemButton: this.component.disabled || this.disabledByUser ? false : _lodash.default.get(this.component, 'removeItemButton', true),
          itemSelectText: '',
          classNames: {
            containerOuter: 'choices form-group formio-choices',
            containerInner: 'form-control'
          },
          addItemText: false,
          placeholder: !!this.component.placeholder,
          placeholderValue: placeholderValue,
          noResultsText: this.t('No results found'),
          noChoicesText: this.t('No choices to choose from'),
          searchPlaceholderValue: this.t('Type to search'),
          shouldSort: false,
          position: this.component.dropdown || 'auto',
          searchEnabled: useSearch,
          searchChoices: !searchField,
          searchFields: this.component.searchFields || (searchField ? ["value.".concat(searchField)] : ['label']),
          fuseOptions: Object.assign({
            include: 'score'
          }, _lodash.default.get(this, 'component.fuseOptions', {})),
          itemComparer: _lodash.default.isEqual
        };
        Object.assign(choicesOptions, customOptions); // Добавлена возможность настраивать параметры поиска

        Object.assign(choicesOptions.fuseOptions, customSearch);
        var tabIndex = input.tabIndex;
        this.addPlaceholder(input);
        input.setAttribute('dir', this.i18next.dir());
        this.choices = new _choices.default(input, choicesOptions);

        if (this.component.multiple) {
          this.focusableElement = this.choices.input.element;
        } else {
          this.focusableElement = this.choices.containerInner.element;
          this.choices.containerOuter.element.setAttribute('tabIndex', '-1');

          if (useSearch) {
            this.addEventListener(this.choices.containerOuter.element, 'focus', function () {
              return _this6.focusableElement.focus();
            });
          }
        }

        this.scrollList = this.choices.choiceList.element;

        this.onScroll = function () {
          if (!_this6.scrollLoading && // Добавлена проверка на не пустую строку поиска
          !_this6.choices.input.element.value && _this6.scrollList.scrollTop + _this6.scrollList.clientHeight >= _this6.scrollList.scrollHeight) {
            _this6.scrollTop = _this6.scrollList.scrollTop;
            _this6.scrollLoading = true;

            _this6.triggerUpdate(_this6.choices.input.element.value);
          }
        };

        this.scrollList.addEventListener('scroll', this.onScroll);
        this.focusableElement.setAttribute('tabIndex', tabIndex);
        this.setInputStyles(this.choices.containerOuter.element); // If a search field is provided, then add an event listener to update items on search.

        if (this.component.searchField) {
          // Make sure to clear the search when no value is provided.
          if (this.choices && this.choices.input && this.choices.input.element) {
            this.addEventListener(this.choices.input.element, 'input', function (event) {
              if (!event.target.value) {
                _this6.triggerUpdate();
              }
            });
          }

          this.addEventListener(input, 'search', function (event) {
            return _this6.triggerUpdate(event.detail.value);
          });
          this.addEventListener(input, 'stopSearch', function () {
            return _this6.triggerUpdate();
          });
        }

        this.addEventListener(input, 'showDropdown', function () {
          _this6.triggerBlockByUser();

          if (_this6.dataValue) {
            _this6.triggerUpdate();
          }

          _this6.update();
        });
        this.addEventListener(input, 'hideDropdown', this.triggerUnblockByUser);

        if (placeholderValue && this.choices._isSelectOneElement) {
          this.addEventListener(input, 'removeItem', function () {
            var items = _this6.choices._store.activeItems;

            if (!items.length) {
              _this6.choices._addItem(placeholderValue, placeholderValue, 0, -1, null, true, null);
            }
          });
        } // Add value options.


        if (this.addValueOptions()) {
          this.restoreValue();
        }

        this.updatePlaceholder(); // Force the disabled state with getters and setters.

        this.disabled = this.disabled;
        this.triggerUpdate();
      }
    }, {
      key: "defaultAddInput",
      value: function defaultAddInput(input, container) {
        if (!input) {
          return;
        }

        if (input && container) {
          input = container.appendChild(input);
        }

        this.inputs.push(input);
        this.hook('input', input, container);
        this.addInputEventListener(input);
        this.addInputSubmitListener(input);
        return input;
      }
    }, {
      key: "setValueByUser",
      value: function setValueByUser(value) {
        this.setValue(value, true);
      }
    }, {
      key: "defaultSchema",
      get: function get() {
        var defaultSchema = _Select.default.schema(),
            customSchema = {
          customOptions: {
            searchResultLimit: 10000,
            searchPlaceholderValue: 'Поиск',
            loadingText: 'Загрузка...',
            noResultsText: 'Результаты не найдены',
            noChoicesText: 'Нет вариантов для выбора'
          },
          customSearch: {
            distance: 10000,
            threshold: 0.2
          }
        };

        return Object.assign(defaultSchema, customSchema);
      }
    }]);

    return Select;
  }((0, _WithLogic2.default)(_Select.default));

  Select.editForm = function () {
    for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
      extend[_key] = arguments[_key];
    }

    return _Base.default.apply(void 0, [[{
      key: 'display',
      components: [{
        type: 'checkbox',
        input: true,
        weight: 15,
        key: 'autoSelectTheOnlyOption',
        label: 'Автоматической выбор единственной опции'
      }]
    }, {
      key: 'data',
      components: editForm
    }]].concat(extend));
  };

  Select.itemsPromise = undefined;
  return Select;
}

var editForm = [{
  type: 'select',
  input: true,
  weight: 0,
  key: 'dataSrc',
  defaultValue: 'values',
  label: 'Источник значений',
  dataSrc: 'values',
  searchEnabled: false,
  data: {
    values: [{
      label: 'Ввести руками',
      value: 'values'
    }, {
      label: 'JSON',
      value: 'json'
    }, {
      label: 'URL',
      value: 'url'
    }, {
      label: 'Каталог',
      value: 'catalog'
    }, {
      label: 'Форма',
      value: 'custom'
    }]
  }
}, // dataSrc === JSON
{
  type: 'textarea',
  as: 'json',
  editor: 'ace',
  weight: 1,
  input: true,
  key: 'data.json',
  label: 'JSON содержащий элементы справочника',
  placeholder: '[{\n' + '  "value": "ha01",\n' + '  "label": "ha"\n' + '}]',
  conditional: {
    json: {
      '===': [{
        var: 'data.dataSrc'
      }, 'json']
    }
  }
}, // dataSrc === url
{
  type: 'textfield',
  input: true,
  key: 'data.url',
  weight: 1,
  label: 'Полный URL для получения элементов справочника',
  placeholder: 'http://project.ru/catalogs/Countries',
  conditional: {
    json: {
      '===': [{
        var: 'data.dataSrc'
      }, 'url']
    }
  }
}, {
  type: 'panel',
  title: 'Дополнительные заголовки запроса',
  theme: 'default',
  collapsible: true,
  collapsed: true,
  key: 'data.headersPanel',
  weight: 2,
  components: [{
    type: 'datagrid',
    input: true,
    label: '',
    key: 'data.headers',
    weight: 11,
    components: [{
      label: 'Key',
      key: 'key',
      input: true,
      type: 'textfield'
    }, {
      label: 'Value',
      key: 'value',
      input: true,
      type: 'textfield'
    }]
  }],
  conditional: {
    json: {
      '===': [{
        var: 'data.dataSrc'
      }, 'url']
    }
  }
}, {
  type: 'textarea',
  input: true,
  editor: 'ace',
  weight: 3,
  key: 'data.extractValues',
  label: 'Js-код, преобразующий ответ в массив элементов справочника',
  tooltip: 'Ответ доступен в переменной response. Не забудьте записать результирующий массив в переменную values.',
  placeholder: "Например: values = response.map(i => { return { value: i.code + '@' + i.catalogCode, label: i.title } });",
  conditional: {
    json: {
      '===': [{
        var: 'data.dataSrc'
      }, 'url']
    }
  }
}, {
  type: 'panel',
  title: 'JS-скрипт для получения данных справочника',
  collapsible: true,
  collapsed: true,
  key: 'customQueryParameterPanel',
  weight: 4,
  components: [_utils.default.logicVariablesTable(), {
    type: 'htmlelement',
    tag: 'div',

    /* eslint-disable prefer-template */
    content: "<p>\u0421\u043A\u0440\u0438\u043F\u0442 \u0431\u0435\u0440\u0435\u0442 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u043F\u043E\u043C\u0435\u0449\u0430\u0435\u0442\u0441\u044F \u0432 \u043F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u0443\u044E <b>result</b> (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, <code>result = {}</code>), \u043A\u043E\u0434\u0438\u0440\u0443\u0435\u0442 \u0435\u0433\u043E (encodeURIComponent(JSON.stringify(result)) \u0438 \u0434\u043E\u0431\u0430\u0432\u043B\u044F\u0435\u0442 \u0432\u044B\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043A URL \u0432 \u0432\u0438\u0434\u0435 query-\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430 'query' </p>"
    /* eslint-enable prefer-template */

  }, {
    type: 'textarea',
    input: true,
    editor: 'ace',
    weight: 3,
    hideLabel: true,
    key: 'customQueryParameter',
    placeholder: 'result = {...}',
    conditional: {
      json: {
        '===': [{
          var: 'data.dataSrc'
        }, 'url']
      }
    }
  }],
  conditional: {
    json: {
      '===': [{
        var: 'data.dataSrc'
      }, 'url']
    }
  }
}, //Если в селекте что-то уже выбрано и включена ленивая загрузка, то до того как справочник загрузится, вместо
// выбранного значения отображается его код из бд

/*{
type: 'checkbox',
input: true,
label: 'Загружать справочник только при необходимости',
key: 'lazyLoad',
tooltip: 'When set, this will not fire off the request to the URL until this control is within focus. This can improve performance if you have many Select dropdowns on your form where the API\'s will only fire when the control is activated.',
weight: 11,
conditional: {
  json: { '===': [{ var: 'data.dataSrc' }, 'url'] }
}
},*/
// dataSrc === catalog
{
  type: 'textfield',
  input: true,
  weight: 1,
  key: 'data.catalogCode',
  label: 'Код каталога в сервисе каталогов',
  placeholder: 'OKSMCountries',
  conditional: {
    json: {
      '===': [{
        var: 'data.dataSrc'
      }, 'catalog']
    }
  }
}, // dataSrc === values
{
  type: 'datagrid',
  input: true,
  label: '',
  key: 'data.values',
  weight: 1,
  reorder: true,
  components: [{
    label: 'Название',
    key: 'label',
    input: true,
    type: 'textfield'
  }, {
    label: 'Код в бд',
    key: 'value',
    input: true,
    type: 'textfield',
    allowCalculateOverride: true,
    calculateValue: {
      _camelCase: [{
        var: 'row.label'
      }]
    }
  }],
  conditional: {
    json: {
      '===': [{
        var: 'data.dataSrc'
      }, 'values']
    }
  }
}, {
  type: 'textarea',
  input: true,
  key: 'data.transform',
  label: 'JS код для преобразования списка выпадающих значений',
  editor: 'ace',
  rows: 10,
  weight: 1,
  placeholder: 'Например: values = values.filter(value => value.label === "За");',
  tooltip: 'Данные формы доступны в массиве values. Не забудьте записать результирующий массив в переменную values.',
  conditional: {
    json: {
      '===': [{
        var: 'data.dataSrc'
      }, 'values']
    }
  }
},
/*{
type: 'checkbox',
input: true,
key: 'disableLimit',
label: 'Disable limiting response',
tooltip: 'When enabled the request will not include the limit and skip options in the query string',
weight: 15,
conditional: {
  json: { '===': [{ var: 'data.dataSrc' }, 'url'] }
}
},
{
type: 'textfield',
input: true,
key: 'searchField',
label: 'Search Query Name',
weight: 16,
description: 'Name of URL query parameter',
tooltip: 'The name of the search querystring parameter used when sending a request to filter results with. The server at the URL must handle this query parameter.',
conditional: {
  json: {
    or: [
      { '===': [{ var: 'data.dataSrc' }, 'url'] },
      { '===': [{ var: 'data.dataSrc' }, 'resource'] }
    ]
  }
}
},
{
type: 'number',
input: true,
key: 'minSearch',
weight: 17,
label: 'Minimum Search Length',
tooltip: 'The minimum amount of characters they must type before a search is made.',
defaultValue: 0,
conditional: {
  json: {
    and: [
      { '===': [{ var: 'data.dataSrc' }, 'url'] },
      { '!=': [{ var: 'data.searchField' }, ''] }
    ]
  }
}
},
{
type: 'textfield',
input: true,
key: 'filter',
label: 'Filter Query',
weight: 18,
description: 'The filter query for results.',
tooltip: 'Use this to provide additional filtering using query parameters.',
conditional: {
  json: {
    or: [
      { '===': [{ var: 'data.dataSrc' }, 'url'] },
      { '===': [{ var: 'data.dataSrc' }, 'resource'] }
    ]
  }
}
},
{
type: 'textfield',
input: true,
key: 'sort',
label: 'Sort Query',
weight: 18,
description: 'The sort query for results',
tooltip: 'User this to provide additional sorting using query parameters',
conditional: {
  json: {
    or: [
      { '===': [{ var: 'data.dataSrc' }, 'url'] },
      { '===': [{ var: 'data.dataSrc' }, 'resource'] }
    ]
  }
}
},
{
type: 'number',
input: true,
key: 'limit',
label: 'Limit',
weight: 18,
defaultValue: 100,
description: 'Maximum number of items to view per page of results.',
tooltip: 'Use this to limit the number of items to request or view.',
conditional: {
  json: {
    or: [
      { '===': [{ var: 'data.dataSrc' }, 'url'] },
      { '===': [{ var: 'data.dataSrc' }, 'resource'] },
      { '===': [{ var: 'data.dataSrc' }, 'json'] }
    ]
  }
}
},*/
// dataSrc === custom
{
  type: 'textarea',
  input: true,
  key: 'data.custom',
  label: 'Js-код, преобразующий данные формы которую заполняет пользователь в массив элементов справочника',
  editor: 'ace',
  rows: 10,
  weight: 1,
  placeholder: "Например: values = data['mykey'];",
  tooltip: 'Данные формы доступны в объекте data. Не забудьте записать результирующий массив в переменную values.',
  conditional: {
    json: {
      '===': [{
        var: 'data.dataSrc'
      }, 'custom']
    }
  }
}, {
  type: 'textfield',
  input: true,
  label: 'Value Property',
  key: 'valueProperty',
  skipMerge: true,
  clearOnHide: false,
  weight: 2,
  tooltip: 'Поле элемента справочника, которое будет храниться в БД'
}, {
  type: 'textarea',
  input: true,
  key: 'template',
  label: 'Шаблон айтема',
  editor: 'ace',
  as: 'html',
  rows: 3,
  weight: 18,
  tooltip: 'HTML'
}, {
  type: 'checkbox',
  input: true,
  weight: 4,
  key: 'searchEnabled',
  label: 'Поиск на клиенте',
  defaultValue: true
},
/*{
type: 'checkbox',
input: true,
weight: 22,
key: 'readOnlyValue',
label: 'Read Only Value',
tooltip: 'Check this if you would like to show just the value when in Read Only mode.'
},*/
{
  type: 'textarea',
  as: 'json',
  editor: 'ace',
  weight: 5,
  input: true,
  key: 'customOptions',
  label: 'Параметры выпадающего списка',
  tooltip: 'Полный список доступных параметров смотрите в Select.js:choicesOptions',
  placeholder: '{\n' + '"noResultsText": "Пусто",\n' + '"searchPlaceholderValue": "Найти"\n' + '}'
}, {
  type: 'textarea',
  as: 'json',
  editor: 'ace',
  weight: 6,
  input: true,
  key: 'customSearch',
  label: 'Параметры поиска выпадающего списка',
  tooltip: 'Полный список доступных параметров смотрите в fusejs.io/api/options',
  placeholder: '{\n' + '"distance": "10000",\n' + '"threshold": "0.2"\n' + '}'
}, {
  type: 'textfield',
  input: true,
  weight: 2,
  validate: {
    pattern: '^\\w*$|^\\w+(,\\s?\\w+)+$'
  },
  label: 'Коды опций, выставляемых по-умолчанию',
  tooltip: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 _\u0427\u0415\u0420\u0415\u0417 \u0417\u0410\u041F\u042F\u0422\u0423\u042E_ \u043A\u043E\u0434\u044B \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0445, \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0441 \u0431\u0435\u043A\u0430, \u0432\u044B \u0445\u043E\u0442\u0435\u043B\u0438 \u0431\u044B \u043F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E \u0432 \u0434\u0430\u043D\u043D\u043E\u0435 \u043F\u043E\u043B\u0435.\n            \u0415\u0441\u043B\u0438 \u043F\u0440\u0438 \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u043E\u0439 \u043E\u043F\u0446\u0438\u0438 multiple \u0432\u044B \u0443\u043A\u0430\u0436\u0435\u0442\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0434\u0430, \u0442\u043E \u0431\u0443\u0434\u0435\u0442 \u0432\u0441\u0442\u0430\u0432\u043B\u0435\u043D \u0441\u0430\u043C\u044B\u0439 \u043F\u0435\u0440\u0432\u044B\u0439 \u0432\u0430\u043C\u0438 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u043A\u043E\u0434.\n            ",
  key: 'defaultCodes',
  skipMerge: true,
  clearOnHide: false,
  placeholder: 'your_code_1,your_code_2'
}];